import { LifeCycle } from 'entities/lifecycle';
import { Split, SplitTest } from 'entities/splitTest';

export interface ServerSplitTest extends LifeCycle {
  id?: string;
  name: string;
  siteConfig: {
    splits: Split[];
  };
}

export const convertToServerSplitTest = (splitTest: SplitTest): ServerSplitTest => {
  const serverSplitTest = {
    ...splitTest,
    name: splitTest.name,
    siteConfig: {
      splits: splitTest.splits || [],
    },
  };
  delete serverSplitTest.splits;
  return serverSplitTest;
};

export const convertToSplitTest = (serverSplitTest: ServerSplitTest): SplitTest => {
  const splitTest = {
    ...serverSplitTest,
    splits: [...serverSplitTest.siteConfig.splits],
  };
  delete splitTest.siteConfig;
  return splitTest;
};
